import React, {useEffect, useState, useCallback, useRef} from 'react';

import {REPLAY, ReplayItem} from 'fetch/works';

import Pager, {usePager} from 'components/Pager';

import IfRender from 'components/IfRender';
import Item from '../Item';
import ReplayInput, {INPUT_TYPE} from '../ReplayInput';
import {showModal} from 'components/Modal';


import s from './index.module.scss';

const PAGE_SIZE = 5;

interface Props {
  commentId: number;
  onCommentNumChange: (number: number) => void
}
  
const ReplayList: React.FC<Props> = ({
  commentId,
  onCommentNumChange
}) => {

  const [list, setList] = useState([] as ReplayItem[])
  const [showPager, setShowPager] = useState(false);
  const [hasData, setHasData] = useState(false);
  const isInitData = useRef(false);

  const {
    currentPage,
    totalPage,
    setCurrentPage,
    setTotal
  } = usePager()


  const fetchFn = useCallback(
    (commentId, currentPage) => {
      REPLAY
      .get({commentId, page: currentPage, size: PAGE_SIZE})
      .then(({dataList, totalCount}) => {
        setList(dataList.map(item => ({
          ...item,
          liked: item.hasPraised
        })));
        setShowPager(totalCount > PAGE_SIZE);
        setTotal((totalCount||0) / PAGE_SIZE)
        setHasData(true);
        onCommentNumChange(totalCount)
        isInitData.current = false;
      }).catch(err => {
        console.log('ReplayList fetch -->', err)
      })
    },
    [commentId, currentPage],
  )

  const initData = useCallback(
    () => {
      isInitData.current = true;
      setCurrentPage(1);
      fetchFn(commentId, 1)
    },
    [commentId],
  )

  useEffect(() => {
    if(isInitData.current) {
      return;
    }
    fetchFn(commentId, currentPage)
  }, [currentPage])


  const onComment = (id: number, flag = true) => {
    const newList = list.map(item => {
      return item.id === id
        ? {...item, showInput: flag}
        : item
    })
    setList(newList)
  }

  const onDelete = (id: number) => {
    showModal(
      '删除回复',
      '确定要删除这条回复吗',
      '删除',
      'red'
    ).then((val: boolean) => {
      if(!val) return;
      REPLAY.del(id).then(() => {
        initData()
      }).catch(err => {
        console.log('ReplayList onDelete -->', err)
      })
    })
    
  }
  const onLicked = (id: number, liked: boolean) => {
    const fetchFn = liked ? REPLAY.unlike : REPLAY.like;
    const num = liked ? -1 : 1;

    fetchFn(id).then(() => {
      const newList = list.map(item => {
        const prePraiseNum = item.praiseNum || 0;
        return item.id === id
          ? {
            ...item,
            liked: !item.liked,
            praiseNum: prePraiseNum + num
          }
          : item
      })
      setList(newList)
    }).catch(err => {
      console.log('ReplayList onLicked err -->', err)
    })

  }

  return (
    <div className={s.replayWrap}>
    {list.map((item) => (
      <div key={item.id} className={s.replayItem}>
        <Item 
          data={item} 
          onComment={() => onComment(item.id)} 
          onLicked={(liked) => onLicked(item.id, !!liked)}
          onDelete={() => onDelete(item.id)}
        />
        <IfRender show={!!item.showInput}>
          <div style={{paddingLeft: '60px', marginLeft: 'auto'}}>
            <ReplayInput 
              commentId={commentId} 
              replyId={item.id} 
              type={INPUT_TYPE.REPLAY} 
              onCancel={() => onComment(item.id, false)} 
              onSuccess={initData}
            />
          </div>
        </IfRender>
      </div>
    ))} 
    <ReplayInput 
      commentId={commentId} 
      type={INPUT_TYPE.COMMENT}
      showInput={hasData && list.length === 0}
      onSuccess={initData}
    />
    <IfRender show={showPager}>
      <div style={{marginBottom: '20px'}}>
        <Pager 
          current={currentPage} 
          total={totalPage || 1}
          onChange={(val) => setCurrentPage(val)} 
          buttonSize={5}
        />
      </div>
    </IfRender>
  </div>
  )
}
export default ReplayList;